import { render, staticRenderFns } from "./workflow-projects-listing.vue?vue&type=template&id=08067eca&scoped=true&"
import script from "./workflow-projects-listing.vue?vue&type=script&lang=js&"
export * from "./workflow-projects-listing.vue?vue&type=script&lang=js&"
import style0 from "./workflow-projects-listing.vue?vue&type=style&index=0&id=08067eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08067eca",
  null
  
)

export default component.exports